<app-master-data-table [data]="masterCommonService.validitiesList" [columns]="validityColumns" title="Validity List"
  addButtonLabel="Validity" (add)="openAddUpdateValidityDialog('add')"
  (update)="openAddUpdateValidityDialog('update', $event)" (delete)="deleteValidity($event)">
</app-master-data-table>